module.exports = __webpack_public_path__ + "img/error.1269cd77.svg";